<template>
  <div class="plot-ctn" :style="{ zoom: zoomRatio }">
    <div :id="`wtplot_${id}`" :style="{ width: w + 'px', height: h + 'px' }">
    </div>
    <div class="legend">
      <chart-plot-legend style="width: 363px;height: 67px;" />
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="legend-low" />
        </template>
        {{$t('Threshold of low BG')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="legend-high" />
        </template>
        {{$t('Threshold of high BG')}}
      </wt-legend>
    </div>
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'
import ChartPlotLegend from '@c/ChartPlotLegend'
import wtLegend from '@c/Legend'
import dayjs from 'dayjs'
import $ from 'jquery'
import * as d3 from 'd3'
import { derrorFactory, errorFactory } from '@u/log'
import { SVG, _appendRoundedCorners } from '@u/reportHelper'
const error = errorFactory('ChartPlot', false)
const derror = derrorFactory('ChartPlot', true)

let _id = 1
// window.$ = $

function _transferToUiData(data = []) {
  const arr = Array.from({ length: 24 }, (v, i) => [])
  const plots = Array.from({ length: 6 }, (v, i) => undefined)
  const plotsIndexes = []
  
  data.forEach((d, i) => {
    const index = 2 + i * 4
    const legal = _legalData(d)
    if (legal) {
      arr[index] = [d.min, d.twentyFivePercent, d.middle, d.seventyFivePercent, d.max]
      plots[i] = [d.min, d.twentyFivePercent, d.middle, d.seventyFivePercent, d.max]
      plotsIndexes.push(i)
    } else {
      arr[index] = undefined
    }
  })
  
  // error(`_transferToUiData, data`, data)
  // error(`_transferToUiData, result arr`, arr)
  // error(`_transferToUiData, result plots`, plots)
  
  return {
    arr: arr.filter(v => v),
    plots,
    plotsIndexes
  }
}

function _legalData(obj = {}) {
  let pass = false
  pass = obj && obj.seventyFivePercent > 0 && obj.middle > 0 && obj.max > 0 && obj.twentyFivePercent > 0
  return pass
}

function drawDiamond(centroid) { // 生成svg的path的d字段
  derror(`drawDiamond, centroid: ${JSON.stringify(centroid)}`)
  const { x, y, w = 12, h = 12 } = centroid
  // Start at the top
  var result = 'M' + x + ',' + (y - h / 2)
  
  // Go right
  result += 'L' + (x + w / 2) + ',' + y
  
  // Bottom
  result += 'L' + x + ',' + (y + h / 2)
  
  // Left
  result += 'L' + (x - w / 2) + ',' + y
  
  // Close the shape
  result += 'Z'
  
  return result
}

export default {
  name: 'CChartPlot',
  mixins: [reDrawTrigger],
  components: {
    ChartPlotLegend,
    wtLegend
  },
  props: {
    noHorizontalSplitLine: {
      type: [Boolean],
      default: false
    },
    values: {
      type: [Array],
      default: () => []
    }
  },
  data() {
    _id++
    const id = `cplot_${+new Date()}_${_id}`
    return {
      id
    }
  },
  computed: {
    w() {
      const ds = this.ds
      return Math.round(ds * (1186 / 1740))
    },
    h() {
      const w = this.w
      const r = 619 / 1186
      return Math.round(r * w)
    }
  },
  mounted() {
    const startOfDay = dayjs().startOf('day')
    const fmt = `HH:mm`
    const hours = Array.from({ length: 25 }).map((v, i) => {
      return startOfDay.add(i, 'hour').format(fmt)
    })
    
    this.renderPlots(false)
  },
  beforeDestroy() {
    try {
      if (this._drawDiamondTimer) {
        clearTimeout(this._drawDiamondTimer)
        this._drawDiamondTimer = null
      }
    } catch (err) {
      error('被捕获:' + err)
    }
  },
  methods: {
    alterAfterEchartsRendered(extra = {}) { // 将中位数改成diamond显示; // 这个函数背后默认的逻辑是，g下面的path的最后6个，就是6个plot;我之前echarts的option里头添加了legend配置，导致最后一个path变成了legend相关的path，从而只修改到了5个plot
      const { id, ds, hasInited = false } = extra
      const { values = [] } = this
      
      const _uid = _transferToUiData(values)
      const _plotsIndexes = _uid['plotsIndexes']
      const _trueLegalPlotCounts = _plotsIndexes.length
      derror(`alterAfterEchartsRendered, hasInited: ${hasInited}|||_trueLegalPlotCounts: ${_trueLegalPlotCounts}`)
      if (hasInited && values && values.length) {
        derror(`认为plot的钻石我已经画过了，这个finished应该是echarts没有silent，鼠标画过、停留触发的finihsed事件。鉴于我们本身不存在updateChart数据逻辑，所以我这边就直接粗暴，不再画diamond. 跳过`)
        return
      }
      if (_trueLegalPlotCounts === 0) {
        derror(`alterAfterEchartsRendered实际需要渲染的plot个数是0，所以直接break掉alterAfterEchartsRendered逻辑，do nothing`)
        return
      }
      
      const $g = $(`#wtplot_${id} svg > g`)
      const $ps = $g.find('>path')
      const $rects = $g.find('>path[fill="#6CD27E"][stroke="#979797"]')
      const l = $ps.length
      derror(`plot g 下面的>path有几个元素,length: ${l}`, {
        $ps,
        $rects
      })
      
      const $plots = [] // 从左到右(0为最左边的plot)(画diamond需要使用到)
      const $horizontalLinePaths = [] // 画高低血糖值的文本需要
      
      const offset = 2 // 为了画高低血糖的标线产生的{offset}个path;同时我新增或删除diamond的path，会导致$g.find('>path')取到的数组里头plot和diamond之间隔了好多个path，所以我就直接将diamond赋予id，这样子再update(hasInited == true)的时候，直接通过id来获取diamond
      
      // /* eslint-disable */
      // return
      
      /* ++++++++++画4个圆角++++++++++ */
      if (!hasInited) {
        // 初始化 init
        const grid = this.getGrid()
        
        const { left, bottom, top, right } = grid
        const { w, h, stripeInnerBorderC, id } = this
        const topLeftCorner = {
          x: left,
          y: top
        }
        
        const bottomRightCorner = {
          x: w - right,
          y: h - bottom
        }
        
        const radiusW = 12
        _appendRoundedCorners($g, {
          borderColor: stripeInnerBorderC,
          id: `${id}_echarts_rcorners_topleft`,
          w: radiusW,
          offsetX: topLeftCorner.x,
          offsetY: topLeftCorner.y,
          isLeft: true
        })
        _appendRoundedCorners($g, {
          borderColor: stripeInnerBorderC,
          id: `${id}_echarts_rcorners_bottomleft`,
          w: radiusW,
          offsetX: topLeftCorner.x,
          offsetY: bottomRightCorner.y,
          isLeft: true,
          isTop: false
        })
        _appendRoundedCorners($g, {
          borderColor: stripeInnerBorderC, 
          id: `${id}_echarts_rcorners_topright`,
          w: radiusW,
          offsetX: bottomRightCorner.x,
          offsetY: topLeftCorner.y,
          isLeft: false
        })
        _appendRoundedCorners($g, {
          borderColor: stripeInnerBorderC, 
          id: `${id}_echarts_rcorners_bottomright`,
          w: radiusW,
          offsetX: bottomRightCorner.x,
          offsetY: bottomRightCorner.y,
          isLeft: false,
          isTop: false
        })
      }
      /* ++++++++++End of 画4个圆角++++++++++ */
      
      /* *********画6个diamond********* */
      /* eslint-disable */
      if (!hasInited) {
        if (_trueLegalPlotCounts > 0) {
          this._diamondDrawed = true // 用来标记，是否已有diamond的path，从而影响alterAfterEchartsRendered的渲染逻辑(通过入参hasInited)
        }
        for (let i = 0; i < 6; i++) {
          const plotDomIndex = i
          const $p = $rects[plotDomIndex]
          const plotDataIndex = _plotsIndexes[i]
          
          if ($p) {
            $plots[plotDataIndex] = $p // 没有diamond对应的path            
          } else {
            $plots[plotDataIndex] = undefined
          }
          // $plots.push($ps[plotIndex]) // 没有diamond对应的path
          // error(`plots[i], i: ${i}, type of value: ${typeof $plots[i]}`)
        }
      }
      
      for (let j = 0; j < 6; j++) {
        /* eslint-disable-next-line */
        const tmp = j
        const $current = hasInited ? ($g.find(`#wtplot_plot_${j + 1}`)) : $plots[j] // 当前plot;从左到右
        
        if (!hasInited) {
          if (!$current) {
            derror(`plot图j: ${j}不存在，所以直接continue了，不做diamond逻辑转换`)
            continue
          } 
        } else {
          // hasInited: true
          if (!$current.length) {
            derror(`plot图钻石id:#wtplot_plot_${j + 1}:的plot不存在，所以直接continue了，不做diamond逻辑转换`)
            continue
          } else {
          }
        }
        
        const needVisible = _plotsIndexes.includes(j)

        
        let d = !$current.getAttribute ? $current.attr('d') : $current.getAttribute('d')
        // let hasDrawDiamond = !$current.getAttribute ? $current.attr('diamond') : $current.getAttribute('diamond')
        
        // if (hasDrawDiamond) {
        
        // }
        
        // TBC.要更"鲁棒性": M、L的大小写; 点是否以 空格 或者 , 来分割
        if (!d) {
          error(`${hasInited ? '[hasInited]' : '[not inited]'}plot的path对象为${d}, 很大原因是echarts的dom元素还没准备好，我们就开始画diamond. 目前的delay时长是: ${this.delayAfterEcharts}`)
          error(`${hasInited ? '[hasInited]' : '[not inited]'}当前j: ${j}, plot理论上的id是: wtplot_plot_${j + 1}; $current: ${$current[0]}`)
          error(`typeof $current.getAttribute ${typeof $current.getAttribute}, typeof attr: ${ typeof $current.attr }`)
          continue
        }
        d = d.toUpperCase()
        const allDs = d.split('M')
        const pointsStr = allDs.pop()
        const twoPoints = pointsStr.split('L')
        const p1 = twoPoints[0]
        const p1Two = p1.split(' ').length ? p1.split(' ') : p1.split(',')
        const p2 = twoPoints[1]
        const p2Two = p2.split(' ').length ? p2.split(' ') : p2.split(',')
        
        const start = {
          x: p1Two[0].trim(),
          y: p1Two[1].trim()
        }
        const onePlotWidth = Math.abs(p1Two[0] - p2Two[0]) // 其中31.39是我设置成1200的ds时候，得到的plot宽度(网页渲染出来的)
        
        const diamondStartPoint = {
          x: +start.x + (onePlotWidth) / 2, // 12是diamond的宽度
          y: +start.y
        }
        
        const diamondD = drawDiamond(diamondStartPoint) // path的d属性
        
        // /* eslint-disable */
        // return 
        
        // 拼凑新的<path>
        if (!$current.setAttribute) {
          $current.attr('d', allDs.join('M')) // 去掉中位数的那根原来的'横线' 
        } else {
          $current.setAttribute('d', allDs.join('M')) // 去掉中位数的那根原来的'横线'
        }
        if (!hasInited) {
          // 将老的plot的path,更新上id
          // error(`将老的plot的path,更新上id: wtplot_plot_${j + 1}`)
          if ($current.setAttribute) {
            $current.setAttribute('id', `wtplot_plot_${j + 1}`)            
          } else {
            $current.attr('id', `wtplot_plot_${j + 1}`)
          }
        }
        
        // 根据是否可见(即是否是placeholder),来打上标记
        if (needVisible) {
          if ($current.setAttribute) {
            $current.setAttribute('opacity', '1')            
          } else {
            $current.attr('opacity', '1')
          }
        } else {
          if ($current.setAttribute) {
            $current.setAttribute('opacity', '0')
          } else {
            $current.attr('opacity', '0')
          }
        }
        
        // 生成diamond相应的path
        if (!hasInited) {
          // 新生成一个path
          const $newPath = $(SVG('path')) // svg元素没有innterHTML，所以通过这种方式，从而使jquery能成功添加path元素 // https://chubao4ever.github.io/tech/2015/07/16/jquerys-append-not-working-with-svg-element.html 
          $newPath.attr('d', diamondD)
          $newPath.attr('fill', 'white')
          $newPath.attr('id', `wtplot_diamond_${j + 1}`)
          
          // 根据是否可见(即是否是placeholder),来控制可见性
          if (needVisible) {
            $newPath.attr('opacity', '1')
          } else {
            $newPath.attr('opacity', '0')            
          }
          $newPath.appendTo($g)
        } else {
          // update相应的diamond的path
          const $newPath = $g.find(`#wtplot_diamond_${j + 1}`)
          if ($newPath && $newPath.length) {            
            if (!$newPath.setAttribute) {
              $newPath.attr('d', diamondD)
              $newPath.attr('fill', 'white')  
            } else {
              $newPath.setAttribute('d', diamondD)
              $newPath.setAttribute('fill', 'white')
            }
            
            // 根据是否可见(即是否是placeholder),来控制可见性
            if (needVisible) {
              if ($newPath.setAttribute) {
                $newPath.setAttribute('opacity', '1')            
              } else {
                $newPath.attr('opacity', '1')
              }
            } else {
              if ($newPath.setAttribute) {
                $newPath.setAttribute('opacity', '0')
              } else {
                $newPath.attr('opacity', '0')
              }
            }         
          } else {
            error(`[ChartPlot]准备更新diamond的时候发现id为: wtplot_diamond_${j + 1}的diamond找不到，所以为了逻辑不崩，直接do nothing`)
          }
        }
      }
      /* *********End of 画6个diamond********* */      
      // /* eslint-enable */
    },
    refreshTriggered() {
      // error(`CharPlot ${this.id}, this.refreshTriggered`)
      this.renderPlots(true)
    },
    renderPlots(isUpdate = false) {
      // /* ++++++++++测试画6个diamond++++++++++ */
      // let hasInited = isUpdate && (this._drawDiamondTimer === null)
      // if (this._drawDiamondTimer) {
      //   clearTimeout(this._drawDiamondTimer)
      // }
      
      // this._drawDiamondTimer = setTimeout(() => {
      //   this._drawDiamondTimer = null
      //   this.alterAfterEchartsRendered({ // 这个函数背后默认的逻辑是，g下面的path的最后6个，就是6个plot;我之前echarts的option里头添加了legend配置，导致最后一个path变成了legend相关的path，从而只修改到了5个plot
      //     id: this.id,
      //     ds: this.ds,
      //     hasInited
      //   })
      // }, this.delayAfterEcharts)
      // /* ++++++++++End of 测试画6个diamond++++++++++ */
      
      // const { id } = this
      // const ds = this.ds
      if (!isUpdate) {
        this.initChart()
      } else {
        this.updateChart()
      }
    },
    getGrid() {
      const { lfs, ds } = this
      
      const uiW = 1754      
      const oneHourW = 45.35 / uiW * ds
      
      const rst = {
        left: (64 / 12) * lfs,
        bottom: lfs * 2,
        top: ((34 + 2) / 12) * lfs,
        right: oneHourW * (45 / 47.19)
      }
      return rst
    },
    getOpt(values = []) {
      const { cmax, cmaxC, cmin, cminC, lfw, lfs, ds, unit, unitRatio, stripeBgC, noHorizontalSplitLine } = this
      
      const hours = ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00', '24:00']
      // const xDatas = ['00:00', '04:00', '08:00', '12:00', '16:00', '20:00', '00:00']
      const xDatas = Array.from({ length: 24 }).map((v, i) => `plot${i + 1}`)
      const xDatas_1 = ['00:00', '04:00', '08:00', '12:00', '16:00', '20:00', '00:00']
      const xDatas2 = ['0-3', '4-7', '8-11', '12-15', '16-19', '20-23']
      
      const grid = this.getGrid()
      
      const xAxis = [
        { // 用来划split 的线，可以的话，再加上间隔颜色
          // type: 'value',
          type: 'category',
          data: hours,
          axisLine: {
            show: true,
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: [stripeBgC, 'white']
            }
          },
          axisTick: {
            show: true, // 不显示刻度
          },
          axisLabel: {
            show: true,
            showMaxLabel: true,
            color: 'black',
            formatter: (v, i) => {
              // const rst = dayjs(v).format('HH:mm')
              // log(`v: ${v}, i: ${i}`)
              if (i % 4 === 0) {
                return v
              } else {
                return ''
              }
            }
          },
          boundaryGap: false,
          splitLine: {
            show: true,
            width: 0.05,
            lineStyle: {
              type: 'solid',
              color: stripeBgC
            }
          }
        },
        { // 用来给plot对齐
          type: 'category',
          data: xDatas,
          axisLine: {
            show: false,
            lineStyle: {
              color: 'yellow'
            }
          },
          axisTick: {
            show: false, // 不显示刻度
          },
          axisLabel: {
            show: false
          },
          boundaryGap: false,
          // splitLine: {
          //   show: true,
          //   width: 0.05,
          //   lineStyle: {
          //     type: 'solid',
          //     color: '#4B90BD'
          //   }
          // }
        }
      ]
      if (noHorizontalSplitLine) { // 画一个顶部的线，从而有border效果
        xAxis.push({
          type: 'category',
          data: hours,
          position: 'top',
          splitLine: {
            show: false
          },
          axisLine: {
            onZero: false, // 默认是true,会导致position: top无效，一直显示在底部
            show: true,
            lineStyle: {
              color: this.stripeInnerBorderC
            },
          },
          axisLabel: {
            show: false,
            showMaxLabel: false
          },
          axisTick: {
            show: false,
            lineStyle: {
              color: 'red'
            }
          },
          minorTick: {
            show: false
          }
        })
      }
      const option = {
        animation: false,
        // legend: { // 去掉legend
        //   data: ['日K', 'MA5', 'MA10', 'MA20', 'MA30'],
        //   inactiveColor: '#777'
        // },
        grid,
        xAxis,
        yAxis: [{
          z: 1,
          type: 'value',
          min: 0,
          // max: unitRatio * 20,
          splitNumber: 4,
          nameGap: 15,
          name: unit,
          minorTick: {
            show: true
          },
          splitLine: {
            show: !noHorizontalSplitLine,
            lineStyle: {
              color: this.stripeInnerBorderC
            }
          },
          axisLine: {
            show: true
          },
          axisTick: {
            show: true, // 显示刻度
          },
          axisLabel: {
            show: true,
            color: 'black'
          }
        }, { // 右边框的效果
          type: 'value',
          min: 0,
          position: 'right',
          axisLine: {
            show: true
          }
        }],
        series: [
          {
            type: 'line',
            data: [],
            lineStyle: {
              width: 2
            },
            symbol: 'none',
            smooth: true,
            markLine: {
              symbol: 'none',
              data: [
                {
                  silent: true, // 鼠标悬停事件  true没有，false有
                  lineStyle: {
                    type: 'dashed',
                    color: cmaxC,
                    width: 1
                  },
                  label: {
                    show: true,
                    position: 'start',
                    distance: [6, 0],
                    color: cmaxC,
                    fontWeight: lfw
                  },
                  yAxis: cmax // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
                },
                {
                  silent: true, // 鼠标悬停事件  true没有，false有
                  lineStyle: {
                    type: 'dashed',
                    color: cminC,
                    width: 1
                  },
                  label: {
                    show: true,
                    position: 'start',
                    distance: [6, 0],
                    color: cminC,
                    fontWeight: lfw
                  },
                  yAxis: cmin
                }
              ]
            },
            markArea: { // 高亮高低血糖中间
              itemStyle: {
                color: 'rgba(187, 234, 139, 0.20)',
                borderColor: '#abccba',
                borderWidth: 0
              },
              data: [
                [{ yAxis: cmin }, { yAxis: cmax }]
              ]
            }
          },
          {
            // type: 'candlestick',
            name: 'Box Plot',
            type: 'boxplot',
            silent: true,
            xAxisIndex: 1,
            itemStyle: {
              color: '#6CD27E',
              // borderColor: '#A7A7A7',
              borderColor: '#979797',
              shadowColor: 'rgba(0, 0, 0, 0.5)',
              shadowBlur: 3,
              borderWidth: 1
            },
            data: (_transferToUiData(values))['arr']
          }
        ]
      }
      return option
    },
    initChart() {
      const { id } = this
      const canvasid = `wtplot_${id}`
      try {
        const myChart = this.$echarts.init(document.getElementById(`${canvasid}`), null, { renderer: 'svg' })
        myChart.on('finished', () => {          
          const hasInited = this._diamondDrawed === true
          const hasAllData = this.values && this.values.length > 0
          const _did = `wtplot_plot_1`
          const $diamond0 = $(`#${_did}`)
          derror(`echart finished ========== 回调, hasInited: ${hasInited}, values非空数组: ${hasAllData}, hasDiamond: ${$diamond0.length}`)
          if (this._drawDiamondTimer) {
            clearTimeout(this._drawDiamondTimer)
          }

          if (hasInited && $diamond0.length) {
            derror(`已经画过diamond了，所以直接return,不再执行画diamond逻辑`)
            return false
          }
          
          this._drawDiamondTimer = setTimeout(() => {
            this._drawDiamondTimer = null
            this.alterAfterEchartsRendered({ // 这个函数背后默认的逻辑是，g下面的path的最后6个，就是6个plot;我之前echarts的option里头添加了legend配置，导致最后一个path变成了legend相关的path，从而只修改到了5个plot
              id: this.id,
              ds: this.ds,
              hasInited
            })
          }, this.delayAfterEcharts)          
        })
        const opt = this.getOpt(this.values)
        
        myChart.setOption(opt)
        
        this._myChart = myChart // 这个echarts实例会在beforeDestroyed被销毁(代码逻辑再mixin/reDrawTrigger.js)
      } catch (err) {
        error('被捕获:' + err)
      }
    },
    updateChart() {
      // log(`updateChart, values: ${this.values}`)
      error(`要注意echart图表更新后，我之前添加的diamond的path，是否依然在svg里头;不再里头的话会容易出错，得修改逻辑`)
      const myChart = this._myChart
      const newOpt = this.getOpt(this.values)
      this.$nextTick(() => {
        try {
          if (myChart) {
            myChart.setOption(newOpt)            
          }
        } catch (err) {
          error('被捕获:' + err)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixin';

$pl: $sizePaddingTopLegend;
.legend {
    @include flexRow(flex-start, flex-start);
    margin-top: $pl * 0.7;
    margin-left: $pl * 2;
    &.legend--row2 {
        margin-top: $pl;
        margin-bottom: $pl + 4px;
    }
    ::v-deep > .wtLegend-ctn {
        margin-left: $pl;
        .wtLegend--icon .svg-icon {
            display: inline-block;
            $w: $sizeLegendSvgIconWidth;
            width: $w;
            height: $w;
        }
        &:first-child {
            margin-left: 0;
        }
    }
}
.plot-ctn {
    display: inline-block;
}
</style>
